"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _hooks = require("@nicbase/hooks");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FlyOutMenu = function FlyOutMenu(_ref) {
  var onCloseMenu = _ref.onCloseMenu,
      anchor = _ref.anchor,
      children = _ref.children,
      className = _ref.className;

  var _useState = (0, _react.useState)({
    top: anchor.y,
    left: anchor.x
  }),
      _useState2 = _slicedToArray(_useState, 2),
      position = _useState2[0],
      setPosition = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      maxHeight = _useState4[0],
      setMaxHeight = _useState4[1];

  var _useWindowSize = (0, _hooks.useWindowSize)(),
      viewportHeight = _useWindowSize.height,
      viewportWidth = _useWindowSize.width,
      scrollY = _useWindowSize.scrollY,
      scrollX = _useWindowSize.scrollX;

  var listRef = (0, _react.useRef)();
  (0, _hooks.useOnClickOutside)(listRef, function () {
    return onCloseMenu();
  });
  (0, _react.useEffect)(function () {
    var _listRef$current;

    var x = anchor.x,
        y = anchor.y,
        width = anchor.width,
        height = anchor.height;

    var _listRef$current$getB = (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.getBoundingClientRect(),
        menuHeight = _listRef$current$getB.height,
        menuWidth = _listRef$current$getB.width;

    var left = x;
    var top = y; // makes sure the menu isn't larger than its space to open to the bottom

    var maxMenuHeight = viewportHeight - y - 32; // check if there is enough space to the side otherwise to the other side

    if (x + menuWidth >= viewportWidth + scrollX) {
      left = x - menuWidth + width;
    } // check if there is enough space to open menu in full size to the bottom && if the position of the menu is on the lower half of the screen
    // otherwise try opening it to the top


    if (y + menuHeight >= viewportHeight + scrollY && y > viewportHeight / 2) {
      // makes sure the menu isn't larger than its space to open to the top
      maxMenuHeight = y + height - 32; // actualHeight makes sure the maxHeight of the menu is correct relative to its position

      var actualHeight = Math.min(menuHeight, maxMenuHeight);
      top = y - actualHeight + height;
    }

    setMaxHeight(maxMenuHeight);
    setPosition({
      top: top,
      left: left
    });
  }, [anchor, maxHeight, position.top, scrollX, scrollY, viewportHeight, viewportWidth]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "flyout-menu",
    className: (0, _classnames["default"])('absolute overflow-y-auto m-0 p-0 z-30 text-base list-none shadow-md bg-white', className),
    style: {
      top: position.top,
      left: position.left,
      maxHeight: maxHeight
    }
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    ref: listRef
  }, children));
};

var _default = FlyOutMenu;
exports["default"] = _default;
FlyOutMenu.defaultProps = {
  children: null,
  className: '',
  onCloseMenu: function onCloseMenu() {}
};